import FirstLevelSection from './FirstLevelSection'
import HomeSection from './HomeSection'
import OtherSection from './OtherSection'

const exports = {
  HomeSection,
  FirstLevelSection,
  OtherSection,
}

export default exports
